import actionTypes from '../actions/actionTypes';

export default function(state = false, action = {}) {
    if (action.type === actionTypes.TOGGLE_LOGOUT) {
        return action.value;
    } else {
        return state;
    }
}
